import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';
import {
  JackpotNormalizedGamesType,
  JackpotType,
  JackpotWin,
  NormalizedJackpotsType,
  TotalJackpotType
} from '../types';
import { defaultJackpots } from './defaults';

export interface IInHouseJackpotsState {
  jackpots: NormalizedJackpotsType;
  totalJackpot: TotalJackpotType;
  games: JackpotNormalizedGamesType;
  ids: JackpotType[];
  jackpotWin: JackpotWin | null;
  currency: string;
}

export const initialState: IInHouseJackpotsState = {
  jackpots: defaultJackpots,
  totalJackpot: {
    convertedAmount: 0,
    maxValue: 0,
    convertedCurrency: ''
  },
  games: {},
  ids: [],
  jackpotWin: null,
  currency: ''
};

export const useInHouseJackpotsStore = createHookStore(
  STORE_NAMES.IN_HOUSE_JACKPOTS,
  initialState
);
export const useInHouseJackpotsSelector = createUseSelector(
  useInHouseJackpotsStore
);
